export const ageTable = [
  {
    height: 115.00,
    ratioToBust: 0.49,
    ratioToWeist: 0.42,
    ratioToHip: 0.52,
    heightSD: 4.40,
    bustSD: 2.80,
    weistSD: 2.80,
    hipSD: 2.80,
  },
  {
    height: 120.00,
    ratioToBust: 0.485,
    ratioToWeist: 0.415,
    ratioToHip: 0.52,
    heightSD: 4.90,
    bustSD: 3.40,
    weistSD: 3.40,
    hipSD: 3.70,
  },
  {
    height: 125.50,
    ratioToBust: 0.48,
    ratioToWeist: 0.41,
    ratioToHip: 0.52,
    heightSD: 5.30,
    bustSD: 4.00,
    weistSD: 4.00,
    hipSD: 4.50,
  },
  {
    height: 131.50,
    ratioToBust: 0.48,
    ratioToWeist: 0.405,
    ratioToHip: 0.52,
    heightSD: 5.70,
    bustSD: 4.50,
    weistSD: 4.40,
    hipSD: 5.20,
  },
  {
    height: 137.50,
    ratioToBust: 0.485,
    ratioToWeist: 0.4,
    ratioToHip: 0.525,
    heightSD: 6.00,
    bustSD: 5.10,
    weistSD: 4.40,
    hipSD: 5.60,
  },
  {
    height: 144.00,
    ratioToBust: 0.49,
    ratioToWeist: 0.4,
    ratioToHip: 0.53,
    heightSD: 6.30,
    bustSD: 5.45,
    weistSD: 4.30,
    hipSD: 5.50,
  },
  {
    height: 149.50,
    ratioToBust: 0.495,
    ratioToWeist: 0.4,
    ratioToHip: 0.54,
    heightSD: 6.10,
    bustSD: 5.40,
    weistSD: 4.00,
    hipSD: 5.20,
  },
  {
    height: 153.00,
    ratioToBust: 0.50,
    ratioToWeist: 0.4,
    ratioToHip: 0.55,
    heightSD: 5.80,
    bustSD: 5.20,
    weistSD: 3.33,
    hipSD: 4.80,
  },
  {
    height: 155.00,
    ratioToBust: 0.51,
    ratioToWeist: 0.4,
    ratioToHip: 0.56,
    heightSD: 5.50,
    bustSD: 5.00,
    weistSD: 3.10,
    hipSD: 4.50,
  },
  {
    height: 157.00,
    ratioToBust: 0.515,
    ratioToWeist: 0.4,
    ratioToHip: 0.565,
    heightSD: 5.25,
    bustSD: 4.80,
    weistSD: 3.30,
    hipSD: 4.30,
  },
  {
    height: 157.50,
    ratioToBust: 0.52,
    ratioToWeist: 0.4,
    ratioToHip: 0.57,
    heightSD: 5.05,
    bustSD: 4.65,
    weistSD: 3.90,
    hipSD: 4.20,
  },
  {
    height: 158.00,
    ratioToBust: 0.52,
    ratioToWeist: 0.4,
    ratioToHip: 0.57,
    heightSD: 4.80,
    bustSD: 4.50,
    weistSD: 4.00,
    hipSD: 4.10,
  },
]
